import { types } from 'mobx-state-tree';

const ProductTypeClass = {
  ARRAY: 'ARRAY',
  BOTTLE_DEPOSIT: 'BOTTLE_DEPOSIT',
  DISCOUNT: 'DISCOUNT',
  GIFT_VOUCHER: 'GIFT_VOUCHER',
  LOW_ORDER_FEE: 'LOW_ORDER_FEE',
  PAYMENT_COST: 'PAYMENT_COST',
  PHYSICAL: 'PHYSICAL',
  SERVICE: 'SERVICE',
  SHIPPING_COST: 'SHIPPING_COST',
};

export const HiddenProductTypes = {
  currentOrder: {
    PAYMENT_COST: ProductTypeClass.PAYMENT_COST,
    SHIPPING_COST: ProductTypeClass.SHIPPING_COST,
    LOW_ORDER_FEE: ProductTypeClass.LOW_ORDER_FEE,
    DISCOUNT: ProductTypeClass.DISCOUNT,
  }
};


export default ProductTypeClass;

export const ProductType = types.enumeration(
  'ProductTypeClass',
  Object.values(ProductTypeClass)
);

export const HiddenCurrentOrderProducts = types.enumeration(
  'HiddenCurrentOrderProductType',
  Object.values(HiddenProductTypes.currentOrder)
);
